// A wait as a duration ("9 min 29 sec"), so it cannot be read as a clock time.
export default function waitText(seconds) {
  const s = Math.max(0, seconds || 0);
  const min = Math.floor(s / 60);
  const sec = s % 60;
  return [min && `${min} min`, (sec || !min) && `${sec} sec`].filter(Boolean).join(' ');
}



// WEBPACK FOOTER //
// ./src/utils/waitText.js